
import React, { useState, useEffect, Fragment, useRef } from 'react'
import {
  Select, Form, Input, Button, Modal,
  Upload, Row, Col, DatePicker, message, InputNumber, Space, Radio, TreeSelect, Tree
} from "antd";
// import { LoadingOutlined, PlusOutlined, MinusCircleOutlined } from '@ant-design/icons';
// import HandleButton from "@/components/HandleButton"
import RoleApi from '@api/role'

import ResourceApi from '@api/resource'
// import Title from '@/components/Title'
// import MinTitle from '@/components/MinTitle'
// import MessageApi from '@api/message'
import AddModal from '@components/Modal'
import { identifierData } from '@utils/common'
import moment from 'moment';
// const { UPLOADER } = window.globalConfig;
import { alarmApi, stationApi, dictApi } from "@api/newApi";
import InspectionApi from '@api/inspectionnew'
import { treeConversion, treeIds, extraIds } from '@utils/common'

const layout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 17 },
};
const { SHOW_PARENT, SHOW_ALL, TreeNode } = TreeSelect;
const Option = Select.Option

export default ({ title, visible, formData = null, cancel,stationData }) => {
  const [form] = Form.useForm();
  const [editBool, setEditBool] = useState(false)
  const [resourceTree, setResourceTree] = useState()
  const [formValue, setFormValue] = useState()
  const [loading, setLoading] = useState()
  // 所有的树形id
  const [allIds, setAllIds] = useState([])
  const [isManager, setIsManger] = useState(0)
  // 处理人列表
  const [personItems, setPersonItems] = useState([])
  const [deviceArry,setDeviceArry] = useState([])
  const [patrolItems, setPatrolItems] = useState() 
  const [defectLevelIdArr,setDefectLevelIdArr] = useState([])
  const [sourceIdArr,setSourceIdArr] = useState([]) 
  const [users, setUsers] = useState([]) 
  const [roleText, setRoleText] = useState([]) 
  // 厂站集合
  const [patrolItemParams, setPatrolItemParams] = useState({
    stationId: '',
    type: '',
    materielId: '',
    processunitClassifyId: '',
    processunitId: '',
    deviceClassifyId: '',
  })
  useEffect(() => {
    // 获取人员列表
    if (formData) {
      RoleApi.queryRoleUserByIdentifier({ stationIds: formData.stationId, identifier: identifierData[0] }).then(res => {
        if (res.status == 0 && res.data) {
          setPersonItems(res.data || [])
        }
      })
    } 
    InspectionApi.upkeepStandard({ pageSize:100,pageNum:1,name: "" }).then(res => {
      setLoading(false)
      if (res.status == 0 && res.data) {
        setSourceIdArr(res.data.data )
      }
    })
    return () => { }
  }, [])
  useEffect(() => {
    if (patrolItemParams.stationId && patrolItemParams.type === 0) {
      
    }
    return () => { }
  }, [patrolItemParams])

  // 切换厂站，查询巡检项
  const changeStation = (val) => {
    getDatas()
  }
    // 获取模版列表, 获取人员列表
  const getDatas = (id=null) => {
    let stationIds = form.getFieldValue('stationId')?form.getFieldValue('stationId') : id;
    if (stationIds) {
      // 获取模版列表
      // InspectionApi.deviceRelevancyTree({},{
      //   headers: {
      //     'X-STATIONID': stationIds
      //   }
      // }).then(res =>{
      //   // console.info(getChild([res.data]))
      //   setDeviceArry(getChild([res.data]))
      // })
      RoleApi.roleByStand({stationId:stationIds}).then(res =>{
        setRoleText(res.data)
      })
      // InspectionApi.getDefectLevelByStationId({stationId:stationIds}).then(res =>{
      //   setDefectLevelIdArr(res.data)
      // })
      // RoleApi.userByStand({stationId:stationIds}).then(res => {
      //   let user = []
      //   Object.keys(res.data).map(key=>{
      //     res.data[key].map(item => {
      //       user.push(item)
      //     })
      //   })
      //   console.info(user)
      //   setUsers(user)
      // })
    }
  }
  const getChild = (arr) => {
    const role = form.getFieldValue('handleRole')
    return arr.map(item => {
      if(item.children && item.children.length > 0){
        item.children = getChild(item.children);
        if(role !='area_manager'){
          item.disabled = item.deviceId?false:true;
        }
        return item;
      } else {
        delete item.children;
        if(role !='area_manager'){
          item.disabled = item.deviceId?false:true;
        }
        return item;
      }

    })
  }
  // 提交
  const submit = () => {
    
    form.validateFields().then(values => {
      if(!values){
        return;
      }
      setLoading(true)
      let param = {...values}
      
      let userOne = roleText.find(it => it.id == values.handleRoleId )
      param.handleRoleName= userOne.name   
      

      if(formData && formData.id){

      } else {
        InspectionApi.upkeepPlanAdd(param).then(res => {
          if (res.status == 0) {
            message.success('添加成功')
            handelCancel(true)
          }
          setLoading(false)
        }).catch((err) => {
          setLoading(false)
        })
      }
      
      
    })
  }
  // 取消
  const handelCancel = (bool = false) => {
    form.resetFields();
    cancel(bool);
  }
  return (
    <AddModal title={title} footer={[
      <Row key={'btn'} span={24}>
        <Button key={1} onClick={handelCancel} className='abuttons'>
          <i className='iconfont iconfanhui'>
          </i>&nbsp;&nbsp;取消
        </Button>
        <Button key={2} loading={loading} onClick={submit} className='abuttons' type="primary">
          <i className='iconfont iconbaocun'>
          </i>&nbsp;&nbsp;保存
        </Button>
      </Row>]
    } visible={visible} width={800} okText={'确定'} onCancel={handelCancel} onSubmit={() => submit()}>
      <div className='userModal'>
        <Form preserve={false}
          {...layout}
          // name="basic"
          layout="horizontal"
          form={form}
          style={{ marginTop: '20px' }}
          initialValues={formValue}
        >
          {/* <Row> */}
          <Col span={18}>
            <Form.Item
              label='保养计划名称'
              name="planName"
              rules={[{ required: true, message: '请输入保养计划名称' }]}
            > 
              <Input row={4} placeholder={'请输入保养计划名称'} />              
            </Form.Item>
          </Col>
          <Col span={18}>
            <Form.Item
              label='巡检场站'
              name="stationId"
              rules={[{ required: true, message: '请选择巡检场站' }]}
            >
              <Select
                allowClear
                onChange={(val) => changeStation(val)}                
                placeholder="请选择">
                {
                  stationData && stationData.map((item, idx) => {
                    return (
                      <Select.Option value={item.value + ''} key={'stationId-' + idx}>{item.title || item.name}</Select.Option>
                    )
                  })
                }
              </Select>
            </Form.Item>
          </Col>  
          <Col span={18}>
            <Form.Item
              label='保养标准'
              name="upkeepStandardId"
              rules={[{ required: true, message: '请选择保养标准' }]}
            >
              <Select
                disabled={editBool} 
                placeholder="请选择">
                 {sourceIdArr.map(item => {
                  return <Select.Option value={item.id} key={`users-${item.id}`}>{item.name}</Select.Option>
                })} 
              </Select>
            </Form.Item>
          </Col>
          <Col span={18}>
            <Form.Item
              label='提前天数'
              name="advanceDay"
              rules={[{ required: true, message: '请输入提前天数' }]}
            > 
              <Input row={4} placeholder={'请输入提前天数'} />
            </Form.Item>
          </Col>
          <Col span={18}>
            <Form.Item
              label='处理角色'
              name="handleRoleId"
              rules={[{ required: true, message: '请选择处理角色' }]}
            >
              <Select
                disabled={editBool} 
                placeholder="请选择">
                 {roleText.map(item => {
                  return <Select.Option value={item.id} key={`usersrule-${item.id}`}>{item.name}</Select.Option>
                })} 
              </Select>
              {/* <Input disabled={editBool} placeholder={'请输入处理人'} /> */}
            </Form.Item>
          </Col>
         
          
          {/* </Row> */}
        </Form>
      </div>
    </AddModal>
  )

}
